// common/hooks/useTariff.ts
import { TariffRule } from '../types/interfaces'

const getCurrentPrice = (tariff: TariffRule): number => {
  if (!tariff.specialPrice) return tariff.basePrice

  const now = new Date()
  const validFrom = tariff.validFrom ? new Date(tariff.validFrom) : null
  const validTo = tariff.validTo ? new Date(tariff.validTo) : null

  if (validFrom && now < validFrom) return tariff.basePrice
  if (validTo && now > validTo) return tariff.basePrice

  return tariff.specialPrice
}

export const useTariff = () => {
  const calculatePrice = (tariff: TariffRule | undefined, durationMonths: number): number => {
    if (!tariff) return 0

    const basePrice = getCurrentPrice(tariff)

    if (!tariff.allowDiscounts) {
      return basePrice * durationMonths
    }

    const discount = tariff.discounts?.find(
      (d) => d.durationMonths === durationMonths && d.isActive,
    )

    if (!discount) {
      return basePrice * durationMonths
    }

    return Math.round(basePrice * durationMonths * (1 - discount.discountPercent / 100))
  }

  const getAvailableDurations = (tariff: TariffRule | undefined): number[] => {
    if (!tariff) return [1]
    if (!tariff.allowDiscounts) return [1]

    const durations = tariff.discounts?.filter((d) => d.isActive).map((d) => d.durationMonths) || []

    return [1, ...durations].sort((a, b) => a - b)
  }

  const getDiscountForDuration = (
    tariff: TariffRule | undefined,
    durationMonths: number,
  ): number => {
    if (!tariff || !tariff.allowDiscounts) return 0
    const discount = tariff.discounts?.find(
      (d) => d.durationMonths === durationMonths && d.isActive,
    )
    return discount?.discountPercent || 0
  }

  return {
    calculatePrice,
    getAvailableDurations,
    getDiscountForDuration,
  }
}
